<confect-select
  placeholder="Select Asset"
  [ngModel]="value.id"
  (ngModelChange)="selectionChanged($event)"
  [name]="specItem.key"
  [options]="OPTIONS"
  bindValue="id"
  bindLabel="display"
/>
